module.exports = __webpack_public_path__ + "static/img/left-man.aec6a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default/left-man.png
// module id = 3Ztq
// module chunks = 2